<template>
  <div
    v-if="enabled"
    id="navCartForm"
    :class="[openClass, 'navbar-cart-form']"
  >
    <span
      class="empty-section"
      @click="cartClose"
    />

    <div class="navbar-vue-cart">
      <div class="header-section">
        <h3 class="header-title">
          {{ $t('navCart.yourItems') }}
        </h3>
        <div class="currency-and-close">
          <CurrencyDropdown :currency="currency" />
          <button
            class="btn"
            @click="cartClose"
          >
            {{ $t('navCart.close') }}
          </button>
        </div>
      </div>

      <Cart @amount-update="updateCart" />

      <div class="checkout-buttons">
        <a
          v-if="amount > 0"
          class="btn proceed-to-checkout"
          :disabled="invalidItems"
          @click="goToCheckout"
        >
          {{ $t('navCart.continue') }}
        </a>
        <button
          class="btn continue-shopping"
          @click="cartClose"
        >
          {{ $t('navCart.keepShopping') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Cart from '../../cart/cart'
import CurrencyDropdown from '../../../default/currency_convert/currency-dropdown'

import { trackPageView as gaTrackPageView } from '../../../default/analytics.js'
import { trackPageView as gtmTrackPageView } from '../../../default/google_tag_manager.js'

export default {
  components: {
    Cart,
    CurrencyDropdown
  },

  data() {
    return {
      amount: 0,
      checkoutLink: '/cart/checkout',
      currency: 'USD',
      display: null,
      enabled: true,
      invalidItems: true,
      navLinkTag: null,
      orderId: null
    }
  },

  computed: {
    openClass() {
      if (this.display == true) {
        return 'display'
      } else if (this.display == false) {
        return 'closed'
      } else {
        return ''
      }
    }
  },

  created() {
    this.navLinkTag = document.getElementById('navCartLink')

    if (document.getElementById('cartNavCheck') == null) {
      this.navLinkTag.addEventListener('click', this.cartDisplay)
    } else {
      this.navLinkTag.href = this.checkoutLink
      this.enabled = false
    }
  },

  methods: {
    cartDisplay() {
      this.display = true
      document.querySelector('body').classList.add('nav-cart-diplaying')
      gaTrackPageView('/cart')
      gtmTrackPageView(`https://${window.location.host}/cart`)
    },

    cartClose() {
      this.display = false
      document.querySelector('body').classList.remove('nav-cart-diplaying')
    },

    goToCheckout() {
      if (this.invalidItems) { return }

      window.location.href = '/cart/checkout'
    },

    updateCart(fields) {
      if (this.amount != fields.amount &&
            this.orderId == fields.orderId &&
            this.currency == fields.currency &&
            fields.cart_version !== 'h4h') {
        this.cartDisplay()
      }

      this.amount = fields.amount
      this.currency = fields.currency
      this.invalidItems = fields.invalidItemsInCart
      this.orderId = fields.orderId
    },
  }
}
</script>
